<script>
	import {Form} from '../../helpers/Form/Form'

	export default {
		props: {
			module: Object,
			partecipant: Object,
			formErrors: Object,
			commonFields: {
				type: Array,
				default() {
					return []
				}
			},
			partecipantIdx: Number,
			moduleIdx: Number,
			allSkipped: {
				type: Boolean,
				default: false
			},
			formComplete: {
				type: Boolean,
				default: false
			}
		},
        data() {
            return {
                radioValues: {}
            };
        },
		watch: {
			'module.form_fields': {
				handler(val) {
					this.handleFieldsDisabled('fields')
				},
				deep: true
			},
			'module.form_responsible_fields': {
				handler(val) {

					this.handleFieldsDisabled('responsible_fields')
				},
				deep: true
			},
            'module.form_default_fields': {
                handler(val) {
                    Object.keys(val).forEach(key => {
                        if (key.includes('default_accept')) {
                            this.radioValues[key] = val[key];
                        }
                    });
                    this.sendAllRadioValues();
                },
                deep: true
            },
			'module.skip': {
				handler(val) {
					this.$bus.$emit('module.skipped', {
						m_idx: this.moduleIdx,
						p_idx: this.partecipantIdx,
						value: val
					})
				}
			}
		},
		mounted() {
            const initialValues = this.module.form_default_fields;
            Object.keys(initialValues).forEach(key => {
                if (key.includes('default_accept')) {
                    this.radioValues[key] = initialValues[key];
                }
            });
            this.$emit('update-radio-values', this.radioValues);
			if (!this.formComplete) {
				this.initField()
			}
		},
		methods: {
            sendAllRadioValues() {
                this.$emit('update-radio-values', this.radioValues);
            },
			initField() {
				this.fillFormFields('fields')
				this.fillFormFields('responsible_fields', 'responsible')
			},
			fillFormFields(field_type, prefix = null) {
				let formFieldsType = `form_${field_type}`

				Object
					.keys(this.module[formFieldsType])
					.forEach(i => {
						let cleanKey = null

						if (prefix) {
							cleanKey = i.replace(`module_${this.module.id}_${prefix}_`, '')
						} else {
							cleanKey = i.replace(`module_${this.module.id}_`, '')
						}

						let idx = this.commonFields.findIndex(i => i.slug == cleanKey)

						if (idx >= 0) {
							let mappedFields = this.commonFields[idx].mapped_by

							Object.keys(mappedFields).forEach(slug => {
								let key = mappedFields[slug]
								let moduleProp = `module_${this.module.id}_${slug}` 
								if (prefix) {
									moduleProp = `module_${this.module.id}_${prefix}_${slug}`
								}

								this.module[formFieldsType][moduleProp] = null

								if (Array.isArray(key)) {
									key.forEach(keyVal => {
										if (prefix) {
											keyVal = `${prefix}_${keyVal}`
										}

										if (this.partecipant.hasOwnProperty(keyVal)) {
											if (this.module[formFieldsType].hasOwnProperty(moduleProp) && this.partecipant[keyVal]) {
												if (this.module[formFieldsType][moduleProp]) {
													let current = this.module[formFieldsType][moduleProp]
													let concat = current.concat(` ${this.partecipant[keyVal]}`)	

													this.module[formFieldsType][moduleProp] = concat
												} else {
													this.module[formFieldsType][moduleProp] = this.partecipant[keyVal]
												}

												if (this.partecipant[keyVal]) {
													let idx = this.module[field_type].findIndex(i => i.slug == moduleProp)
													if (idx >= 0) {
														this.module[field_type][idx].disabled = true
													}
												}
											}
										}
									})
								} else {
									if (prefix) {
										key = `${prefix}_${key}`
									}

									if (this.partecipant.hasOwnProperty(key)) {
										if (this.module[formFieldsType].hasOwnProperty(moduleProp) && this.partecipant[key]) {
											this.module[formFieldsType][moduleProp] = this.partecipant[key]

											if (this.partecipant[key]) {
												let idx = this.module[field_type].findIndex(i => i.slug == moduleProp)
												if (idx >= 0) {
													this.module[field_type][idx].disabled = true
												}	
											}										
										}
									}
								}		
							})				
						}
					})
			},
			isFieldType(field, type) {
				if (_.isObject(field.type)) {
					return field.type.code_name == type
				}

				return field.type == type
			},
            isFieldOptional(field) {
                return field.is_optional === true;
            },
			getFieldOptions(field) {
				let options = []

				field.options.forEach(i => {
					if (_.isObject(i) && i.hasOwnProperty('opt')) {
						options.push(i.opt)
					} else {
						options.push(i)
					}
				})

				return options
			},
			handleFieldsDisabled(fields) {
				let idx = -1

				for (let prop in this.module[`form_${fields}`]) {
					idx = this.module[fields].findIndex(i => i.slug == prop)

					if (idx >= 0) {
						let field = this.module[fields][idx]

						if (field.disabled_if) {
							let rules = field.disabled_if
							let result = false

							rules.forEach(pair => {
								let splitRule = pair.split(':')
								let dependencyFieldName = `module_${this.module.id}_${splitRule[0]}`
								let dependencyFieldValue = splitRule[1]

								let currentValue = this.module[`form_${fields}`][dependencyFieldName]		

								result = dependencyFieldValue == currentValue						
							})

							this.$set(field, 'disabled', result)
							if (result) {
								this.$set(this.module[`form_${fields}`], prop, null)
							}
						}
					}							
				}				
			},			
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/purchases/VoucherPartecipantModuleForm.vue